module.exports = __webpack_public_path__ + "static/media/1017057.ed633f99.png";